import { customFetch } from "@/client/custom-fetch";

import {
  IResetPasswordRequest,
  IResetPasswordResponse,
} from "./reset-password.types";

export const resetPasswordApi = {
  resetPassword: async (
    data: IResetPasswordRequest
  ): Promise<IResetPasswordResponse> => {
    return customFetch<IResetPasswordResponse>("/user/reset-password", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
  },
};
